<div id="selection-popup" class="warning-popup actuation">
    <h2 class="m-b-5" mat-dialog-title>Edición de Actuación</h2>
    <div mat-dialog-content id="leave-popup-fields">
        <div>
            
            <form [formGroup]="form">
 <!-- <p>myForm value: {{ form.value | json }}</p> -->
                <div class="w25">
                    <mat-label>Fecha</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="picker" formControlName="fecha" [max]="maxFecha">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="w75 author-field">
                    <mat-label>Autor</mat-label>
                    <div class="bottom-line">
                        <mat-form-field appearance="fill">
                            <input matInput formControlName="authorReadonly" readonly>
                        </mat-form-field>
                        <mat-icon class="f-s-19" (click)="openAuthorEditDialog()">edit</mat-icon>
                        <mat-error *ngIf="form.get('authorReadonly').invalid && form.get('authorReadonly').touched">
                            <span *ngIf="form.get('authorReadonly').hasError('required')">
                                Obligatorio
                            </span>
                        </mat-error>
                    </div>
                </div>


                <div class="w100">
                    <mat-label>Texto</mat-label>
                    <mat-form-field>
                        <textarea matInput rows="7" formControlName="comentarios"></textarea>
                    </mat-form-field>
                </div>
                <div class="w100" *ngIf="isEditingComentariosEmpresa || form.controls['comentariosEmpresa'].value?.trim()">
                    <mat-label>Comentario para la Empresa</mat-label>
                    <mat-form-field>
                        <textarea 
                            matInput 
                            rows="7" 
                            formControlName="comentariosEmpresa" 
                            (focus)="startEditingComentariosEmpresa()"
                            (blur)="stopEditingComentariosEmpresa()">
                        </textarea>
                    </mat-form-field>
                </div>
            </form>
        </div>
        <div class="text-a-r p-t-5">
            <button mat-raised-button color="accent" class="m-r-15" (click)="DoModifications()">Guardar</button>
            <button mat-raised-button color="warn" (click)="Close()">Cancelar</button>
        </div>
    </div>
</div>